import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Target, X } from 'lucide-react'

const GoalPromptBanner = ({ currentUser }) => {
  const { t, i18n } = useTranslation()
  const [dismissed, setDismissed] = useState(false)

  if (dismissed) return null
  if (!currentUser) return null
  if (currentUser.training_goal && currentUser.training_goal.trim() !== '') return null

  return (
    <div className="bg-blue-500/10 border border-blue-500/30 rounded-xl p-4 mb-6">
      <div className="flex items-center gap-3">
        <Target className="text-blue-400 flex-shrink-0" size={20} />
        <p className="text-blue-400 font-bold text-sm flex-1">{t('goal_banner.title')}</p>
        <div className="flex items-center gap-2 flex-shrink-0">
          <a
            href={`/users/edit?locale=${i18n.language}`}
            className="bg-gradient-to-r from-orange-500 to-orange-600 text-white font-bold text-xs px-4 py-2 rounded-lg hover:opacity-90 transition-opacity"
          >
            {t('set_goal_link')}
          </a>
          <button
            onClick={() => setDismissed(true)}
            className="text-gray-600 hover:text-gray-400 transition-colors"
          >
            <X size={16} />
          </button>
        </div>
      </div>
      <p className="text-gray-400 text-xs mt-2">{t('goal_banner.description')}</p>
    </div>
  )
}

export default GoalPromptBanner
